module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Series"
    }
  }, [_vm._v("Series Editor’s Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01#ch1"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v(" The Strategic Context")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter02#ch2"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])]), _vm._v(" The Last Stand on the Yser")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])]), _vm._v(" Inundation")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])]), _vm._v(" The Northernmost Part of the Western Front")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])]), _vm._v(" Politics and the Shaping of Memory")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")])]), _vm._v(" The Tours")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_TourA",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tour A")])]), _vm._v(" Nieuwpoort, Lombardsijd and Ramskapelle")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_TourB",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tour B")])]), _vm._v(" Diksmuide")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_TourC",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tour C")])]), _vm._v(" The Belgian Rear of the Yser Front")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_TourD",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tour D")])]), _vm._v(" Drie-Grachten, Merkem and Steenstraat")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_TourE",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "chap"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tour E")])]), _vm._v(" The Towns of the Belgian Rear")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm_1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Othernotable",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Notable Sites in the Area")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_app",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix: The Belgian Army")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selective Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0